/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { usePrefix } from '../../internal/usePrefix.js';

const SkeletonPlaceholder = _ref => {
  let {
    className,
    ...other
  } = _ref;
  const prefix = usePrefix();
  const skeletonPlaceholderClasses = cx({
    [`${prefix}--skeleton__placeholder`]: true
  }, className);
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: skeletonPlaceholderClasses
  }, other));
};
SkeletonPlaceholder.propTypes = {
  /**
   * Add a custom class to the component
   * to set the height and width
   */
  className: PropTypes.string
};

export { SkeletonPlaceholder as default };
